import { ApplicationInsights as ApplicationInsightsWeb } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
var ApplicationInsights = /** @class */ (function () {
    function ApplicationInsights() {
    }
    ApplicationInsights.prototype.initialize = function (instrumentationKey) {
        this.reactPlugin = new ReactPlugin();
        this.applicationInsights = new ApplicationInsightsWeb({
            config: {
                instrumentationKey: instrumentationKey,
                extensions: [this.reactPlugin],
                extensionConfig: {
                // [reactPlugin.identifier]: { history: browserHistory }
                }
            }
        });
        this.applicationInsights.loadAppInsights();
    };
    return ApplicationInsights;
}());
export default new ApplicationInsights();
//# sourceMappingURL=ApplicationInsights.js.map